import { Component, Input } from "@angular/core";

@Component({
  selector: "app-pho-table-dynamic",
  templateUrl: "./pho-table-dynamic.component.html",
  styleUrls: ["./pho-table-dynamic.component.scss"],
})
export class PhoTableDynamicComponent {
  @Input() mainHeader: string = "";
  @Input() subHeaders: string[] = ["Model", "Simulation"];
  @Input() rowLabels: string[] = [];
  @Input() categories: Array<{
    title: string;
    data: {
      [rowLabel: string]: {
        [subHeader: string]: { value: number | string; percentage: string };
      };
    };
  }> = [];
}
